var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuMentions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-mentions") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-mentions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "at-sign",
    transform: "translate(3.000000, 3.000000)",
    stroke: "#646464",
    strokeWidth: 1.75
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 9,
    r: 3.375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6001599,5.40004982 L12.6001599,9.89982806 C12.6001599,11.3909234 13.8089553,12.599695 15.30008,12.599695 C16.7912046,12.599695 18,11.3909234 18,9.89982806 L18,8.99987242 C17.9997366,4.81769264 15.1184063,1.18683035 11.0455806,0.236372069 C6.97275495,-0.714086208 2.78188416,1.26636613 0.930435909,5.01641972 C-0.921012342,8.76647331 0.054937084,13.297749 3.28600118,15.9531704 C6.51706528,18.6085919 11.1516518,18.6882856 14.4721045,16.1455203",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMentions);
export default __webpack_public_path__ + "static/media/menu-mentions.ece03a9d36516e5ee8a60fced7eb8605.svg";
export { ForwardRef as ReactComponent };